import axios from '../axios-auth';
import orginal_axios from "axios";

export const priceModelService = {
    getPriceModelList,
    savePriceModel,
    getPriceModelDetail,
    getAllPriceModelList,
    getPriceModelExcelExport,
    getPriceModelExcelTemplate,
    savePriceModelExcel,
    getPriceModelDetailProduct,
    savePriceModelDetail,
    deletePriceModelDetail,
    getPriceModelDetailExcelExport,
}

function getPriceModelList(searchParams, page, size, sortedBy) {
    let params = {};
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    if (sortedBy == 'null,asc') {
        params["page"] = page;
        params["size"] = size;
    } else {
        params["page"] = page;
        params["size"] = size;
        params["sort"] = sortedBy;
    }
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }
    if (typeof (searchParams.isExistRegion) == 'boolean') {
        params['isExistRegion'] = searchParams.isExistRegion;
    }
    return axios.get("/auth/price-model/", { params });
}

function getAllPriceModelList(searchParams) {
    let params = {};

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }
    if (typeof (searchParams.isExistRegion) == 'boolean') {
        params["isExistRegion"] = searchParams.isExistRegion;
    }

    return axios.get("/auth/price-model", { params });
}

function savePriceModel(priceModel) {
    if (!priceModel.id) {
        // new priceModel
        return axios.post("/auth/price-model", priceModel);
    } else {
        // edit
        return axios.put("/auth/price-model", priceModel);
    }
}

function getPriceModelDetail(id) {
    return axios.get("/auth/price-model/" + id);
}

function getPriceModelExcelExport(searchParams) {
    let params = {};

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }
    if (typeof (searchParams.isExistRegion) == 'boolean') {
        params["isExistRegion"] = searchParams.isExistRegion;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/price-model/price-model-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getPriceModelExcelTemplate() {
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/price-model/price-model-excel-template",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function savePriceModelExcel(file) {
    return axios.post('/auth/price-model/price-model-excel',
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}

function getPriceModelDetailProduct(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.priceModelId) {
        params["priceModelId"] = searchParams.priceModelId;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.priceType) {
        params["priceType"] = searchParams.priceType;
    }
    return axios.get('/auth/price-model/details', { params });
}

function savePriceModelDetail(detail) {
    if (!detail.id) {
        // new
        return axios.post("/auth/price-model/detail", detail);
    } else {
        // edit
        return axios.put("/auth/price-model/detail", detail);
    }
}

function deletePriceModelDetail(priceModelDetail) {
    let params = {};
    params["priceModelId"] = priceModelDetail.priceModelId;
    params["productUnitId"] = priceModelDetail.productUnitId;
    return axios.delete("/auth/price-model/detail", { params });
}

function getPriceModelDetailExcelExport(searchParams) {
    let params = {};

    if (searchParams.priceModelId) {
        params["priceModelId"] = searchParams.priceModelId;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.priceType) {
        params["priceType"] = searchParams.priceType;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/price-model/price-model-detail-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}
